import getVideoId from 'get-video-id';

export const getVideoIframeUrl = (videoUrl, params = {}) => {
    const { id, service } = getVideoId(videoUrl);

    const { controls = '1', autoplay = '0' } = params;

    if (service === 'youtube') {
        return `https://www.youtube.com/embed/${id}?autoplay=${autoplay}&mute=1&loop=1&controls=${controls}&disablekb=1&modestbranding=1&rel=0&&playlist=${id}`;
    } else if (service === 'vimeo') {
        return `https://player.vimeo.com/video/${id}?autoplay=${autoplay}&muted=1&loop=1`;
    }

    return null;
};

let loadYouTubeIframeAPI = null;

export const loadYouTubeAPI = () => {
    if (!loadYouTubeIframeAPI) {
        loadYouTubeIframeAPI = new Promise((resolve) => {
            if (window.YT && window.YT.Player) {
                resolve(window.YT);
            } else {
                const tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/iframe_api';
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                window.onYouTubeIframeAPIReady = () => resolve(window.YT);
            }
        });
    }

    return loadYouTubeIframeAPI;
};

